/* eslint-disable array-callback-return */
import {useEffect, useState} from 'react';
import CustomButton from '../../shared/atomic_components/button/CustomButton';
import './Homepage.css'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { SegnalazioniService } from '../../services/controllers/segnalazioni-services/SegnalazioniService';
import SegnalazioneType from '../../shared/variables/SegnalazioniType';
import { SegnalazioneLightList, SegnalazioneLight } from '../../services/models/objs/SegnalazioneLight';
import User from '../../services/models/output-objs/User';
import CONSTANTS from '../../shared/utils/Constants';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FiltroSection from './components/FiltriSection';
import SegnalazioniStructureService from '../../services/controllers/segnalazioni-services/SegnalazioniStructureService';
import { filtroSection, filtroSectionInt } from '../../services/models/objs/filterSection';
import { LineOfInquiry } from '../../services/models/objs/LineOfInquiry';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField } from '@mui/material';
import { Button } from 'react-bootstrap';
import AddLoiSection from './components/Loi/AddLoi';
import CustomDeleteLoiIconButton from '../../shared/atomic_components/button/CustomDeleteLoiIconButton';
import { LoiInt } from '../../services/models/objs/LineOfInquirySection';
import CustomModifyLoiIconButton from '../../shared/atomic_components/button/CustomModifyLoiIconButton';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import SegnalazioniTableGrid from './components/SegnalazioniTableGrid';
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButtonComponent from '../../shared/atomic_components/button/DropdownButton';
import CustomAssignmentLoiIconButton from '../../shared/atomic_components/button/CustomAssignmentLoiIconButton';
import ManageFunzionariLoiSection from './components/Loi/ManageFunzionari';

type HomepageType = {
    notificationFunctions : any,
    user : User,
    refresh:boolean,
}

const customStylePrimary = {
    color: "#004D99",
    width: 30,
    height: 30,
};

const Homepage = ({notificationFunctions, user, refresh} : HomepageType) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorElReport, setAnchorElReport] = useState(null);
    const open = Boolean(anchorEl);
    const openReport = Boolean(anchorElReport);
    const [segnalazioni, setSegnalazioni] = useState<SegnalazioneLight[]>([]);
    const [supSegnalazioni, setSupSegnalazioni] = useState<SegnalazioneLight[]>([]);
    const [loi, setLoi] = useState<LineOfInquiry[]>([]);
    const [totalElement, setTotalElement] = useState<number>(0);
    const [InCompilazioneElement, setInCompilazioneElement] = useState<number>(0);
    const [InviateElement, setInviateElement] = useState<number>(0);
    const [RettificataElement, setRettificataElement] = useState<number>(0);
    const [CancellaElement, setCancellataElement] = useState<number>(0);
    const [OtherElement, setOtherElement] = useState<number>(0);
    const segnalazioniService : SegnalazioniService = new SegnalazioniService();
    const [filterStructure,setfilterStructure] = useState<filtroSectionInt>(readFilterStructure())
    const [filter,setfilter] = useState<filtroSection>({})
    const [showFiltro, setShowFiltro] = useState(true)
    const [openLoi, setOpenLoi] = useState(false);
    const [openAddLoi, setOpenAddLoi] = useState(false);
    const [openAssignLoi, setOpenAssignLoi] = useState(false);
    const [openStorList, setOpenStorList] = useState(false);
    const [loiStructure,setLoiStructure] = useState<LoiInt>()
    const [funzionariLoiStructure,setFunzionariLoiStructure] = useState<any>()
    const [loiForm, setLoiForm] = useState<{[key : string] : string}>({});
    const [updateForm, setUpdateForm] = useState<{[key : string] : string}>({});
    const [associatedStorLoi, setAssociatedStorLoi] = useState<any[]>([]);
    const [modifyButtonLoi, setModifyButtonLoi] = useState<boolean>(false)

    const handleClick = (event : any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickReport = (event : any) => {
        setAnchorElReport(event.currentTarget);
    };
    const handleCloseReport = () => {
        setAnchorElReport(null);
    };

    useEffect(() => {
        getSegnalazioniEffect()
        toggleShowFiltro()
    }, []) // [] means run only ones

    useEffect(() => {
        getSegnalazioniEffect()
    }, [refresh]) // [] means run only ones

    useEffect(()=>{},[segnalazioni])

    function toggleShowFiltro() {
        setShowFiltro(!showFiltro)
    }

    
    const handleCancel = () => {
        setOpenLoi(false)
        setOpenAddLoi(false)
        setOpenAssignLoi(false)
        setOpenStorList(false)
    }

    const backButton = async () => {
        await getLineOfInquiry();
        setOpenLoi(true)
        setOpenAddLoi(false)
        setOpenAssignLoi(false)
        setOpenStorList(false)
    }

    async function getSegnalazioniEffect(){
        let cercaFiltro = filter
        if(sessionStorage.getItem("filter")){
            let filterString : string | null = sessionStorage.getItem("filter")
            if(filterString != null){
                let value : {[key : string] : string} = {}
                value = JSON.parse(filterString)
                cercaFiltro = value
            }
        }
        try{
            const response = await segnalazioniService.getFilteredListStor(cercaFiltro, user.selectedGroup);
            let newDate : Date
            response.elements?.forEach(element =>{
                if(element.sentDate){
                    newDate = new Date(element.sentDate)
                    element.sentDate = newDate.toLocaleDateString()
                }
                element.financialString = getInstrument(element)
            })
            parseResponseStorList(response);
        }
        catch(e){
            setSegnalazioni([]);
            setSupSegnalazioni([]);
            setTotalElement(0);

        }
    }

    async function getLineOfInquiry(){
        const structure = SegnalazioniStructureService.getLoiStructure();
        const funzionariStructure = SegnalazioniStructureService.getFunzionariLoiStructure();
        setLoiStructure(structure.section)
        setFunzionariLoiStructure(funzionariStructure.section)
        try{
            const response = await segnalazioniService.getLineOfInquiry();
            response.elements.map(loi =>{
                loi.showNote = true;
            })
            setLoi(response.elements);
        }
        catch(e){
            setLoi([]);
        }
    }

    function readFilterStructure() {
        let structure 
        if(user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole)){
            structure = SegnalazioniStructureService.getFiltroStructure();
        }else{
            structure = SegnalazioniStructureService.getFiltroExternalStructure();
        }
        return structure.section

    }

    function filterSetter(filteredStor:any, filter: any){
        setfilter(filter);
        parseResponseStorList(filteredStor); 
    }

    async function exportFile() {
        const service = new SegnalazioniService();
        const response = await service.getExportStor(filter,user.selectedGroup);
        const mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        if(response){
            let binary = '';
            let bytes = new Uint8Array(response);
            let len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
                binary += String.fromCharCode( bytes[ i ] );
            }
            let esito = window.btoa( binary );
            const linkSource = `data:${mimeType}; base64,${esito}`;
            var a = document.createElement('a');
            a.href = linkSource;
            const today = new Date();
            const yyyy = today.getFullYear();
            let mm : any = today.getMonth() + 1; // Months start at 0!
            let dd : any = today.getDate();

            if (dd < 10) dd = '0' + dd;
            if (mm < 10) mm = '0' + mm;

            a.download = 'elenco_segnalazioni_' + dd+mm+yyyy + '.xlsx';
            a.textContent = 'Download file!';
            a.click() 
        }
    }

    function parseResponseStorList(response?: SegnalazioneLightList){
        const segnalazioni = response? response.elements? response.elements : [] : [];
        const totalElement = response? response.totalElements? response.totalElements: 0 : 0;
        let inCompilazioneStor = 0;
        let protocollateStor = 0;
        let rettificateStor = 0;
        let cancellateStor = 0;
        let daCompletareStor = 0;
        segnalazioni.map(segnalazione =>{
            if(segnalazione.state === CONSTANTS.storInCompilazione)
                inCompilazioneStor ++;
            else if(segnalazione.state === CONSTANTS.storInviate)
                protocollateStor ++;
            else if(segnalazione.state === CONSTANTS.storRettificate)
                rettificateStor ++;
            else if(segnalazione.state === CONSTANTS.storCancellate)
                cancellateStor ++;
            else if(segnalazione.state === CONSTANTS.storDaCompletare)
                daCompletareStor ++;
        })
        let otherState = totalElement - inCompilazioneStor - protocollateStor - rettificateStor
        setInCompilazioneElement(inCompilazioneStor)
        setInviateElement(protocollateStor)
        setRettificataElement(rettificateStor)
        setCancellataElement(cancellateStor)
        setOtherElement(otherState)
        setTotalElement(totalElement);
        setSegnalazioni(segnalazioni);
        setSupSegnalazioni(segnalazioni);
    }

    function handleNuovaSegnalazioneClick(type : string) {
        sessionStorage.removeItem('newSegnalazione')
        sessionStorage.setItem('segnalazioneType', type)
        window.location.href = "/stor-fe/stor/create"
    }

    function showNote(singleLoi: any, state: boolean){
        let tmpLoi : LineOfInquiry[] = []
        Object.assign(tmpLoi, loi) 
        tmpLoi.map((element:any) =>{
            if(element.idLoi === singleLoi.idLoi)
                element.showNote = state
        })
        setLoi(tmpLoi)
    }

    async function submitDeleteStor(currentSegnalazione?: SegnalazioneLight){
        if(currentSegnalazione){
            await segnalazioniService.deleteStorByID(currentSegnalazione.id);
            getSegnalazioniEffect();
        }
    }

    function orderByDateAsc(segnalazioni:SegnalazioneLight[]) : SegnalazioneLight[]{
        let tmpSegnalazioni : any = {}
        segnalazioni.forEach(s => {
            if(s.sentDate){
                let support = s.sentDate.split("/")
                s.supportSentDate = new Date(+support[2], +support[1] - 1, +support[0])
            }
        });
        tmpSegnalazioni = segnalazioni.sort((a,b) => (a.supportSentDate?.getTime() ?? 0) - (b.supportSentDate?.getTime() ?? 0))
        return segnalazioni
    }

    function orderByDateDesc(segnalazioni:SegnalazioneLight[]) : SegnalazioneLight[]{
        let tmpSegnalazioni : any = {}
        segnalazioni.forEach(s => {
            if(s.sentDate){
                let support = s.sentDate.split("/")
                s.supportSentDate = new Date(+support[2], +support[1] - 1, +support[0])
            }
        });
        tmpSegnalazioni = segnalazioni.sort((a,b) => (b.supportSentDate?.getTime() ?? 999999999) - (a.supportSentDate?.getTime() ?? 999999999))
        return segnalazioni
    }

    async function submitOrderStor(parameter : string, order: string){
        if(parameter && order==='asc'){
            let tempSegnalazioni : SegnalazioneLight[] = []
            switch(parameter){
                case 'id': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.id ?? "").localeCompare(b?.id ?? "")); break;
                case 'externalProtocolNumber': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.externalProtocolNumber ?? "").localeCompare(b?.externalProtocolNumber ?? "")); break;
                case 'protocolNumber': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.protocolNumber ?? "").localeCompare(b?.protocolNumber ?? "")); break;
                case 'reportingSubject': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.reportingSubject ?? "").localeCompare(b?.reportingSubject ?? "")); break;
                case 'sentDate': tempSegnalazioni = orderByDateAsc(segnalazioni); break;
                case 'type': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.type ?? "").localeCompare(b?.type ?? "")); break;
                case 'financialIntrumentCode': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.type ?? "").localeCompare(b?.type ?? "")); break;
                case 'suspicionType': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.suspicionType ?? "").localeCompare(b?.suspicionType ?? "")); break;
                case 'state': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.state ?? "").localeCompare(b?.state ?? "")); break;
                case 'loi': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.lineOfInquiry ?? "").localeCompare(b?.lineOfInquiry ?? "")); break;
                case 'livello': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.livello ?? "").localeCompare(b?.livello ?? "")); break;
                case 'score': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.score ?? 0) - (b?.score ?? 0)); break;
                case 'funzionario': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.esitoProposto ?? "").localeCompare(b?.esitoProposto ?? "")); break;
                case 'esitoProp': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.esitoProposto ?? "").localeCompare(b?.esitoProposto ?? "")); break;
            }
            setSegnalazioni(tempSegnalazioni); 
        }
        else if(parameter && order==='des'){
            let tempSegnalazioni : SegnalazioneLight[] = []
            switch(parameter){
                case 'id': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.id ?? "").localeCompare(a?.id ?? "")); break;
                case 'externalProtocolNumber': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.externalProtocolNumber ?? "").localeCompare(a?.externalProtocolNumber ?? "")); break;
                case 'protocolNumber': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.protocolNumber ?? "").localeCompare(a?.protocolNumber ?? "")); break;
                case 'reportingSubject': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.reportingSubject ?? "").localeCompare(a?.reportingSubject ?? "")); break;
                case 'sentDate': tempSegnalazioni = orderByDateDesc(segnalazioni); break;
                case 'type': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.type ?? "").localeCompare(a?.type ?? "")); break;
                case 'financialIntrumentCode': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.type ?? "").localeCompare(a?.type ?? "")); break;
                case 'suspicionType': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.suspicionType ?? "").localeCompare(a?.suspicionType ?? "")); break;
                case 'state': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.state ?? "").localeCompare(a?.state ?? "")); break;
                case 'loi': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.lineOfInquiry ?? "").localeCompare(a?.lineOfInquiry ?? "")); break;
                case 'livello': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.livello ?? "").localeCompare(a?.livello ?? "")); break;
                case 'score': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.score ?? 0) - (a?.score ?? 0)); break;
                case 'funzionario': tempSegnalazioni = segnalazioni.sort((a, b) => (a?.esitoProposto ?? "").localeCompare(b?.esitoProposto ?? "")); break;
                case 'esitoProp': tempSegnalazioni = segnalazioni.sort((a, b) => (b?.esitoProposto ?? "").localeCompare(a?.esitoProposto ?? "")); break;
            }
            setSegnalazioni(tempSegnalazioni); 
        }
        else if(parameter && order==='null'){
            let tempSegnalazioni : SegnalazioneLight[] = []
            Object.assign(tempSegnalazioni, supSegnalazioni)
            setSegnalazioni(tempSegnalazioni); 
        }
    }

    async function searchAndOpenLoi(){
        await getLineOfInquiry()
        setOpenLoi(true)
    }

    async function addLoi(){
        setModifyButtonLoi(false)
        setOpenLoi(false)
        setOpenAssignLoi(false)
        setOpenAddLoi(true)
    }

    function modifyLoi(loi : any){
        if(loi){
            const tmpModLoi : {[key : string] : any} = {}
            tmpModLoi['loiName'] = loi.loiName;
            tmpModLoi['loiDemacoFileNumber'] = loi.loiDemacoFileNumber;
            tmpModLoi['loiNote'] = loi.loiNote;
            tmpModLoi['notaMabFileNet'] = loi.notaMabFileNet;
            tmpModLoi['internalLoiId'] = loi.internalLoiId;
            tmpModLoi['idLoi'] = loi.idLoi
            setUpdateForm(tmpModLoi)
            setModifyButtonLoi(true)
            setOpenLoi(false)
            setOpenAddLoi(true)
        }

    }

    function modifyAssignmentLoi(loi : any){
        if(loi){
            const tmpModLoi : {[key : string] : any} = {}
            tmpModLoi['loiName'] = loi.loiName;
            tmpModLoi['loiDemacoFileNumber'] = loi.loiDemacoFileNumber;
            tmpModLoi['loiNote'] = loi.loiNote;
            tmpModLoi['notaMabFileNet'] = loi.notaMabFileNet;
            tmpModLoi['internalLoiId'] = loi.internalLoiId;
            tmpModLoi['idLoi'] = loi.idLoi
            tmpModLoi['assignments'] = loi.assignments
            setUpdateForm(tmpModLoi)
            setOpenLoi(false)
            setOpenAssignLoi(true)
        }

    }

    async function openListStor(loi : any){
        if(loi && loi.idLoi){
            const responseStor = await segnalazioniService.getStorLineOfInquiry(loi.idLoi);
            if(responseStor){
                responseStor.elements?.forEach((element: any) =>{
                    element.financialString = getInstrument(element)
                })
                setAssociatedStorLoi(responseStor.elements)
                setOpenLoi(false)
                setOpenAddLoi(false)
                setOpenAssignLoi(false)
                setOpenStorList(true)
            }
        }
    }

    async function submitDeleteLoi(currentLoi?: any){
        if(currentLoi){
            await segnalazioniService.deleteLineOfInquiry(currentLoi.idLoi);
            notificationFunctions.setSuccessMessage('Line of Inquiry eliminata con successo')
            handleCancel();
        }
    }

    async function createLoi(){
        if(loiForm && loiForm['loiName']){
            let subString = loiForm['loiName'].substring(0, 4);
            if(!isNaN(+subString)){
                const resp = await segnalazioniService.createLineOfInquiry(loiForm);
                setOpenLoi(false)
                setOpenAddLoi(false)
                setOpenAssignLoi(false)
                setOpenStorList(false)
                notificationFunctions.setSuccessMessage('Nuova Line of Inquiry creata con successo')
            }
            else{
                notificationFunctions.setErrorMessage('Il nome della Line of Inquiry deve iniziare con 4 caratteri numerici')
            }
        }
    }

    function getFunzionarioLeader(loi?: any ){
        if (!loi?.assignments?.length) return '';
        const righe = loi.assignments.map((singleFunz: any) => {
            if(singleFunz.assignmentType && singleFunz.assignmentType.id === 1)
                return singleFunz.storOfficerId?.cognome || '';
        });

        return righe
    }

    function getFunzionario(loi?: any) {
        if (!loi?.assignments?.length) return '';

        const righe = loi.assignments
            .filter((s: any) => s?.assignmentType?.id !== 1)
            .map((s: any) => {
                return s?.storOfficerId?.cognome?.trim() || '';
            })
            .filter(Boolean);

        if (righe.length === 0) return '';
        if (righe.length === 1) return righe[0];

        return righe.join('\n').trim();
    }

    async function updateLoi(){
        if(loiForm && loiForm['loiName']){
            let subString = loiForm['loiName'].substring(0, 4);
            if(!isNaN(+subString)){
                await segnalazioniService.updateLineOfInquiry(loiForm);
                setOpenLoi(false)
                setOpenAddLoi(false)
                setOpenAssignLoi(false)
                setOpenStorList(false)
                notificationFunctions.setSuccessMessage('Line of Inquiry modificata con successo')

            }
            else{
                notificationFunctions.setErrorMessage('Il nome della Line of Inquiry deve iniziare con 4 caratteri numerici')
            }
        }
    }

    async function produceVerbale(type : string){
        const service = new SegnalazioniService();
        const mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        let response = undefined
        switch (type) {
            case 'AG' : response = await service.getReportAssegnazione(user.selectedGroup, filter); break;
            case 'AA' : response = await service.getReportAssegnazioneAperte(user.selectedGroup, filter); break;
            case 'AM' : response = await service.getReportAssegnazioneMax(user.selectedGroup, filter); break;
            case 'MC' : response = await service.getReportMacro(user.selectedGroup, filter); break;
        }
        if(response && response.name !== 'AxiosError'){
            let binary = '';
            let bytes = new Uint8Array(response);
            let len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
                binary += String.fromCharCode( bytes[ i ] );
            }
            let esito = window.btoa( binary );
            const linkSource = `data:${mimeType}; base64,${esito}`;
            var a = document.createElement('a');
            a.href = linkSource;
            const today = new Date();
            const yyyy = today.getFullYear();
            let mm : any = today.getMonth() + 1; // Months start at 0!
            let dd : any = today.getDate();

            if (dd < 10) dd = '0' + dd;
            if (mm < 10) mm = '0' + mm;

            switch (type) {
                case 'AG' : a.download = 'Assegnazioni_generali_' + dd+mm+yyyy + '.xlsx'; break;
                case 'AA' : a.download = 'Assegnazioni_aperte_' + dd+mm+yyyy + '.xlsx'; break;
                case 'AM' : a.download = 'Assegnazioni_massimo_dettaglio_' + dd+mm+yyyy + '.xlsx'; break;
                case 'MC' : a.download = 'Macro_categorie_' + dd+mm+yyyy + '.xlsx'; break;
            }

            a.textContent = 'Download file!';
            a.click() 
        }
        else{
            notificationFunctions.setErrorMessage('Errore nella produzione del verbale, riprovare più tardi')
        }

    }

    function getInstrument(segnalazione : any) : string{
        let instrumentString = ''
        if(segnalazione.financialIntrumentCode && segnalazione.financialIntrumentCode.length>2)
            instrumentString = 'Più strumenti finanziari'
        else if(segnalazione.financialIntrumentCode.length>0){
            segnalazione.financialIntrumentCode.forEach((instr:string) => {
                if(instrumentString === '')
                    instrumentString = instr
                else 
                    instrumentString = instrumentString + ',' + instr
            });
        }
        return instrumentString
    }

    return (
        <div>
            <div className="d-inline"> 
                <Dialog
                    open={openLoi}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    PaperProps={{className:"fixed-dialog"}}
                    >
                    <DialogTitle id="alert-dialog-title">
                    Line Of Inquiry
                    </DialogTitle>
                    <DialogContent>
                        <div className="custom-table mb-5">
                            <div className="font-medium-custom table-header mt-3">
                                <div className="my-auto table-element font-table" style={{width: '150px'}}>Operazioni</div>
                                <div className="my-auto table-element font-table" style={{width: '230px'}}>Line of Inquiry</div>
                                <div className="my-auto table-element font-table" style={{width: '150px'}}>N° Segnalazioni</div>
                                <div className="my-auto table-element font-table" style={{width: '150px'}}>Punteggio</div>
                                <div className="my-auto table-element font-table" style={{width: '200px'}}>Funzionaro Leader</div>
                                <div className="my-auto table-element font-table" style={{width: '200px'}}>Funzionari Assegnati</div>
                                <div className="my-auto table-element font-table" style={{width: '70px'}}>Nota</div>
                            </div>
                            {loi.map((singleLoi) =>{
                                return <div>
                                <div key={singleLoi.internalLoiId} className="shadow pointer table-row mt-2 mb-2">
                                        <div className="table-element" style={{width: '150px'}}>
                                            <CustomModifyLoiIconButton title={'Modifica Loi'}
                                                currentLoi={singleLoi}
                                                onCallBack={(singleLoi?: any) => modifyLoi(singleLoi)}/>
                                            <CustomDeleteLoiIconButton title={'Cancella Loi'}
                                                modalTitle={'Elimina Line of Inquiry'}
                                                modalBody={'Confermando la Line of Inquiry verrà eliminata, sicuro di voler procedere?'}
                                                currentLoi={singleLoi}
                                                onCallBack={(singleLoi?: any) => submitDeleteLoi(singleLoi)}/>
                                            <CustomAssignmentLoiIconButton title={'Gestisci Funzionari'}
                                                currentLoi={singleLoi}
                                                onCallBack={(singleLoi?: any) => modifyAssignmentLoi(singleLoi)}/>
                                        </div>
                                        <div className="table-element" style={{width: '230px'}}  onClick={() => {openListStor(singleLoi)}}> {singleLoi.loiName}</div>
                                        <div className="table-element" style={{width: '150px'}}  onClick={() => {openListStor(singleLoi)}}> {singleLoi.loiCardinality}</div>
                                        <div className="table-element" style={{width: '150px'}}  onClick={() => {openListStor(singleLoi)}}> {singleLoi.loiCalculatedScore}</div>
                                        <div className="table-element" style={{width: '200px'}}  onClick={() => {openListStor(singleLoi)}}> {getFunzionarioLeader(singleLoi)}</div>
                                        <div className="table-element" style={{width: '200px'}}  onClick={() => {openListStor(singleLoi)}}> {getFunzionario(singleLoi)}</div>
                                        {singleLoi.showNote?
                                            <div className="table-element" style={{width: '70px'}}> 
                                                <div className="d-inline w-25">
                                                    <IconButton aria-label="modify" style={customStylePrimary} onClick={() => {showNote(singleLoi,false)}} title="Chiudi Nota" >
                                                        <ArrowDropDownIcon />
                                                    </IconButton>
                                                </div>
                                            </div>
                                            :
                                            <div className="table-element" style={{width: '70px'}}> 
                                                <div className="d-inline w-25">
                                                    <IconButton aria-label="modify" style={customStylePrimary} onClick={() => {showNote(singleLoi,true)}} title="Vedi Nota" >
                                                        <ArrowDropUpIcon />
                                                    </IconButton>
                                                </div>
                                            </div>
                                        }
                                </div>
                                <div key={singleLoi.internalLoiId + 'note'} className="shadow table-row mt-2 mb-2" hidden={singleLoi.showNote}>
                                    <TextField
                                        autoFocus
                                        rows={5}
                                        multiline
                                        disabled
                                        margin = "dense"
                                        id = {singleLoi.internalLoiId + "note"}
                                        type = "text"
                                        defaultValue={singleLoi.loiNote}
                                        fullWidth
                                    />
                                </div>
                            </div>
                            })
                            }
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {addLoi()}}>Aggiungi Loi</Button>
                        <Button onClick={handleCancel}>Uscita</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openAddLoi}
                    // onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    PaperProps={{className:"fixed-dialog"}}
                    >
                    <DialogTitle id="alert-dialog-title">
                    Aggiunta/Modifica Loi
                    </DialogTitle>
                    <DialogContent>
                        <AddLoiSection section = {loiStructure} loiUpdate = {updateForm} callback = {setLoiForm}/>
                    </DialogContent>
                    <DialogActions>
                        {modifyButtonLoi? 
                            <Button onClick={updateLoi}>Conferma</Button>
                            :
                            <Button onClick={createLoi}>Conferma</Button>
                        }
                        <Button onClick={backButton}>Indietro</Button>
                        <Button onClick={handleCancel}>Uscita</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openAssignLoi}
                    // onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    PaperProps={{className:"fixed-dialog"}}
                    >
                    <DialogTitle id="alert-dialog-title">
                        Gestisci Funzionari
                    </DialogTitle>
                    <DialogContent>
                        <ManageFunzionariLoiSection section = {funzionariLoiStructure} loiUpdate = {updateForm} notificationFunctions = {notificationFunctions}/>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={backButton}>Indietro</Button>
                        <Button onClick={handleCancel}>Uscita</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openStorList}
                    // onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    PaperProps={{className:"fixed-dialog"}}
                    >
                    <DialogTitle id="alert-dialog-title">
                    Elenco Segnalazioni Associate
                    </DialogTitle>
                    <DialogContent>
                        <div className="custom-table mb-5">
                            <div className="font-medium-custom table-header mt-3">
                                <div className="my-auto table-element font-table" style={{width: '160px'}}>Identificativo</div>
                                <div className="my-auto table-element font-table" style={{width: '200px'}}>Protocollo Consob</div>
                                <div className="my-auto table-element font-table" style={{width: '200px'}}>Soggetto Segnalante</div>
                                <div className="my-auto table-element font-table" style={{width: '200px'}}>Strumento Finanziario</div>
                                <div className="my-auto table-element font-table" style={{width: '100px'}}>Score</div>
                            </div>
                            {associatedStorLoi.length > 0 ?
                                <div>
                                    {associatedStorLoi.map((singleStor) =>{
                                        return <div key={singleStor.id} className="shadow pointer table-row mt-2 mb-2">
                                            <div className="table-element" style={{width: '160px'}}> {singleStor.id}</div>
                                            <div className="table-element" style={{width: '200px'}}> {singleStor.protocolNumber}</div>
                                            <div className="table-element" style={{width: '200px'}}> {singleStor.reportingSubject}</div>
                                            <div className="table-element" style={{width: '200px'}}> {singleStor.financialString}</div>
                                            <div className="table-element" style={{width: '100px'}}> {singleStor.score}</div>
                                        </div>
                                    })}
                                </div>
                                :
                                <div className='mt-4 text-center'>
                                    Nessuna Segnalazione Associata
                                </div>
                            }
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={backButton}>Indietro</Button>
                        <Button onClick={handleCancel}>Esci</Button>
                    </DialogActions>
                </Dialog>
            </div>
            {user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole) ?
                    <div className="row mt-5">
                        <div className="col-md-4 col-sm-6">
                            <div className="card card-body">
                                <p className="color-secondary font-large-custom">Segnalazioni in compilazione</p>
                                <p className="color-primary font-x-large-custom">{InCompilazioneElement}</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-6">
                            <div className="card card-body">
                                <p className="color-secondary font-large-custom">Segnalazioni Inviate</p>
                                {
                                    (RettificataElement > 0)?
                                    <p className="color-primary font-x-large-custom">{InviateElement} (+{RettificataElement} Integrate)</p>
                                    :
                                    <p className="color-primary font-x-large-custom">{InviateElement}</p>
                                }
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-6">
                            <div className="card card-body">
                                <p className="color-secondary font-large-custom">Segnalazioni in analisi o concluse</p>
                                <p className="color-primary font-x-large-custom">{OtherElement}</p>
                            </div>
                        </div>
                    </div>:
                    <div className="row mt-5">
                        <div className="col-md-6 col-sm-6">
                            <div className="card card-body">
                                <p className="color-secondary font-large-custom">Segnalazioni in compilazione</p>
                                <p className="color-primary font-x-large-custom">{InCompilazioneElement}</p>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <div className="card card-body">
                                <p className="color-secondary font-large-custom">Segnalazioni Inviate</p>
                                {
                                    (RettificataElement > 0)?
                                    <p className="color-primary font-x-large-custom">{InviateElement} (+{RettificataElement} Integrate)</p>
                                    :
                                    <p className="color-primary font-x-large-custom">{InviateElement}</p>
                                }
                            </div>
                        </div>
                    </div>
            }
            <div>
                <div className="row mt-5 mb-4">
                    <div className="col-auto font-medium-custom text-bold">
                        Filtri
                    </div>
                    <div className="d-flex col-auto text-bold pointer color-primary">
                        <span onClick={() => toggleShowFiltro()}>
                            {
                                showFiltro ?
                                    <KeyboardArrowUpIcon/>
                                    :
                                    <ExpandMoreIcon/>
                            }
                        </span>
                    </div>
                </div>
                {showFiltro ?
                    <>
                    {
                        <FiltroSection {...filterStructure} callback = {filterSetter} user={user}/>
                    }
                    </> : <></>
                }
            </div>
            <div className="row mt-5">
                <div className="col-5">
                    <p className="my-auto color-secondary font-large-custom">{totalElement} Segnalazion{totalElement === 1 ? 'e' : 'i'}</p>
                </div>
                <div className="col-7 my-auto d-flex justify-content-end">
                    <CustomButton   onClick={exportFile}
                                className="margin-right-5 col-auto"
                                variant="contained">
                                Esporta su Excel
                    </CustomButton> 
                    {user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole) && user.selectedGroup !== 'revisore'?
                        <CustomButton aria-controls={open ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        onClick={handleClickReport}
                                        variant="contained"
                                        className="margin-right-5 col-auto">
                            Produci Reportistica
                        </CustomButton>
                        :
                        <></>
                    }
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorElReport}
                        open={openReport}
                        onClose={handleCloseReport}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}>
                        <MenuItem onClick={() => produceVerbale('AG')}>Assegnazioni in Generale</MenuItem>
                        <MenuItem onClick={() => produceVerbale('AA')}>Assegnazioni Aperte</MenuItem>
                        <MenuItem onClick={() => produceVerbale('AM')}>Assegnazioni al Massimo Dettaglio</MenuItem>
                        <MenuItem onClick={() => produceVerbale('MC')}>Macro Categorie</MenuItem>
                    </Menu>
                    {user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole) && user.selectedGroup === 'deskStor' ?
                        <CustomButton   onClick={() => {searchAndOpenLoi()}}
                                    className="margin-right-5 col-auto"
                                    variant="contained">
                                    Line of Inquiry
                        </CustomButton> 
                        : 
                        <></>
                    }
                    {user?.ldapSource?.toLowerCase().includes(CONSTANTS.externalUserRole) || user.selectedGroup === 'deskStor'?
                        <CustomButton aria-controls={open ? 'basic-menu' : undefined}
                                        aria-haspopup="true"
                                        aria-expanded={open ? 'true' : undefined}
                                        className="margin-right-5 col-auto"
                                        onClick={handleClick}
                                        variant="contained">
                            Nuova segnalazione
                        </CustomButton>
                        :
                        <></>
                    }
                    {user?.ldapSource?.toLowerCase().includes(CONSTANTS.internalUserRole) ?
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}>
                            <MenuItem onClick={() => handleNuovaSegnalazioneClick(SegnalazioneType.STOR)}>STOR</MenuItem>
                            <MenuItem onClick={() => handleNuovaSegnalazioneClick(SegnalazioneType.MARKET_OBSERVATION)}>Market Observation</MenuItem>
                            <MenuItem onClick={() => handleNuovaSegnalazioneClick(SegnalazioneType.ALTRO)}>Altro</MenuItem>
                        </Menu>
                        :
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}>
                            <MenuItem onClick={() => handleNuovaSegnalazioneClick(SegnalazioneType.STOR)}>STOR</MenuItem>
                            <MenuItem onClick={() => handleNuovaSegnalazioneClick(SegnalazioneType.MARKET_OBSERVATION)}>Market Observation</MenuItem>
                        </Menu>
                    }
                </div>
            </div>

            <SegnalazioniTableGrid
                elements={segnalazioni} 
                user={user} 
                deleteCallBack={(currentSegnalazione: SegnalazioneLight) => submitDeleteStor(currentSegnalazione)}
                orderCallBack={(parameter: string, order: string) => submitOrderStor(parameter,order)}
            />

        </div>
    )
}

export default Homepage;
